import { axiosInstanceProducts } from "./instance";

export const postPaymentTokenization = (data) => {
  return axiosInstanceProducts.post(
    `/payments/tokenization-customer`, data
  );
};

export const getCustomerAgreementsTokenization = (id, agreement) => {
  return axiosInstanceProducts.get(
    `/payments/agreement-lines/agremment/${agreement}/customer/${id}`
  );
};

export const postPaymentMethodByCustomer = (data) => {
  return axiosInstanceProducts.post(
    `/payments/tokenization-customer-line`, data
  );
};

export const getPaymentMethodsByCustomer = (id) => {
  return axiosInstanceProducts.get(
    `/payments/paymenth-methods-by-costumer/${id}`
  );
};

export const getBanks = (tokenizable = 0) => {
  return axiosInstanceProducts.get(
    `/banks?page=1&limit=1000&tokenizable=${tokenizable}`
  );
};

export const getDocumentTypes = () =>
  axiosInstanceProducts.get('/members/get-document-type')


export const sendErrorMessage = (data) => {
  return axiosInstanceProducts.post(
    `/emails/send-emails-by-errors`, data
  );
};

export const getProposal = (uuid) => {
  return axiosInstanceProducts.get(`/proposal?p=${uuid}`);
};

export const getProductRecommended = () => {
  return axiosInstanceProducts.get(`/proposals/products-recommended`);
};


export const postProposalsLogs = (data) => {
  return axiosInstanceProducts.post(`/proposals/history-log`, data);
};
